import { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from '../../../types/default-cloud-graph-design-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { LucidIcon, LucidSearchResultIcon } from './icon';

export const lucidConfig: ThirdPartyConfig = {
	displayName: 'Lucid',
	id: 'lucid',
	resourceType: ProductResourceTypes3P.Lucid,
	icon: get3PLogo(LucidIcon, 'Lucid', 'medium'),
	searchResultIcon: get3PLogo(LucidSearchResultIcon, 'Lucid', 'large'),
	integrationAri: 'ari:cloud:platform::integration/lucid',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
};
